<template>
  <path pid="0" d="M14 24v-8a1 1 0 00-2 0v8a1 1 0 002 0zM10 22v-8a1 1 0 00-2 0v8a1 1 0 002 0z"/><path pid="1" d="M4.38 17a1 1 0 101.25-1.56 7 7 0 1111.15-7.19 1 1 0 001 .75H19a4 4 0 011.59 7.66 1 1 0 00-.5 1.34 1 1 0 001.32.52A6 6 0 0019 7h-.52a9 9 0 10-14.1 10z"/><path pid="2" d="M18 22v-8a1 1 0 00-2 0v8a1 1 0 002 0z"/>
</template>
